import { render, staticRenderFns } from "./ProductGrowthChart.vue?vue&type=template&id=366725da&"
import script from "./ProductGrowthChart.vue?vue&type=script&lang=js&"
export * from "./ProductGrowthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports